/* src/courses/actions.js */

import {
  fetchCoursesAdminTypes,
  fetchCoursesTypes,
  addCourseTypes,
  editCourseTypes,
  removeCourseTypes,
  searchCoursesTypes,
  SET_COURSE_PAGE,
  SET_COURSE_PAGE_COUNT,
} from './action_types';
import { makeQuery, makeMutation } from '../../config/client';
import {
  FETCH_COURSES_ADMIN_QUERY,
  FETCH_COURSES_QUERY,
  ADD_COURSE_MUTATION,
  EDIT_COURSE_MUTATION,
  REMOVE_COURSE_MUTATION,
  SEARCH_COURSES_QUERY,
} from './api';

/**
 * @param {Object} variables - variables to pass into the query.
 * @param {string[]} variables.universities - university ids.
 * @returns {function} funciton to fetch courses.
 */
export const fetchCourses = variables => makeQuery(variables)(
  fetchCoursesTypes,
  FETCH_COURSES_QUERY,
);

export const fetchCoursesAdmin = variables => makeQuery(variables)(
  fetchCoursesAdminTypes,
  FETCH_COURSES_ADMIN_QUERY
);

/**
 * @param {Object} variables - variables to pass into the mutation.
 * @param {string} variables.university - university id.
 * @param {Object} variables.courseInput - CourseInput!.
 * @returns {function} - function to add a course.
 */
export const addCourse = variables => makeMutation({ variables })(
  addCourseTypes,
  ADD_COURSE_MUTATION,
);

/**
 * @param {Object} variables - variables to pass into the mutation.
 * @param {string} variables.course - course id.
 * @param {Object} variables.courseInput - CourseInput!.
 * @returns {function} - function to edit a course.
 */
export const editCourse = variables => makeMutation({ variables })(
  editCourseTypes,
  EDIT_COURSE_MUTATION,
);

/**
 * @param {Object} variables - variables to pass into the mutation.
 * @param {string} variables.course - course id.
 * @returns {function} - function to remove a course.
 */
export const removeCourse = variables => makeMutation({ variables })(
  removeCourseTypes,
  REMOVE_COURSE_MUTATION,
);

export const searchCourses = variables => makeQuery(variables)(
  searchCoursesTypes,
  SEARCH_COURSES_QUERY
);

export const setCoursePage = payload => ({ type: SET_COURSE_PAGE, payload });

export const setCoursePageCount = payload => ({ type: SET_COURSE_PAGE_COUNT, payload });



// WEBPACK FOOTER //
// ./src/modules/courses/actions.js